import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest} from "../../api";

export const getDashboardData = createAsyncThunk('home/getDashboardData', async() => {
    try{
        const {data} = await getRequest('coach/dashboard')
        return data
    }
    catch(err){
        console.log(err.response.data.message)
    }
})


const homeSlice = createSlice({
    name: 'home',
    initialState: {
        dashboardData: {}
    },
    reducers: {},
    extraReducers(buillder){
        buillder
            .addCase(getDashboardData.fulfilled, (state, action) => {
                state.dashboardData = action.payload
            })
            .addCase(getDashboardData.rejected, (state, action) => {
                state.dashboardData = {
                    "coach_provided_program": 0,
                    "coach_motions": 0,
                    "satisfaction": 0,
                    "new_program_requests": 0
                }
            })
    }
})

export const selectDashboardData = state => state.home.dashboardData

export default homeSlice.reducer